<template>
<div class="c-carousel-visual" :class="{'c-carousel--center': isCenter}">
  <div ref="swiper" class="swiper">
    <ul class="swiper-wrapper">
      <li class="swiper-slide" v-for="item in kvData" :key="item">
        <div class="c-item">
          <div class="c-item__photo">
            <img :src="item.src" alt="" width="750" height="990" @load="vueImgLoaded" />
          </div>
          <div class="c-item__title">
            <dl class="c-list" v-if="item.list && item.list.length">
              <dd v-for="list in item.list" :key="list">
                <a v-if="list.url" class="is-name" :href="list.url" target="_blank" v-html="list.title"></a>
                <span v-if="!list.url" class="is-name" v-html="list.title"></span>
                <span class="is-price">{{list.price}}</span>
              </dd>
            </dl>
          </div>
        </div>
      </li>
    </ul>
    <div class="swiper-scrollbar"></div>
  </div>
</div>
</template>

<script>
import {gsap, Power3, Expo} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper, {FreeMode, Scrollbar, Mousewheel} from 'swiper';

export default {
  data() {
    return {
      max: 0,
      counter: 0,
      kvData: null,
      oSwiper: null,
      isSetSwipe: false,
      isCenter: false,
      preWidth: 0,
    }
  },
  props: ['name'],
  mounted() {
    // ページデータ
    this.kvData = this.$store.getters.kvData[this.name];

    window.addEventListener('resize', this.resize);
    this.$nextTick(this.settingSwipe);

    // 画像 横or縦
    this.max = this.kvData.length;
    for (let i = 0; i < this.max; i++) {
      const img = new Image();
      img.onload = () => {
        this.loaded({width: img.width, height: img.height});
      }
      img.src = this.kvData[i].src;
    }
  },
  methods: {
    once() {
      this.resize();

      // 表示
      const swiper = this.$el.querySelector('.swiper');
      const scrollbar = this.$el.querySelector('.swiper-scrollbar');
      let view = gsap.timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: 'top 90%',
          end: 'top 10%',
          // once: true,
          scrub: true,
          // markers: true,
        }
      });

      view.addLabel('start')
      .fromTo(swiper, {
        y: 120,
      }, {
        duration: 1.0,
        y: 0,
        clearProps: 'all',
        ease: Expo.easeOut,
      }, 'start')
      .fromTo(swiper, {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Expo.easeOut
      }, 'start+=0.1')
      .fromTo(scrollbar, {
        y: 120,
      }, {
        duration: 1.0,
        y: 0,
        clearProps: 'all',
        ease: Expo.easeOut,
      }, 'start+=0.2')
      .fromTo(scrollbar, {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Expo.easeOut
      }, 'start+=0.3');
    },
    settingSwipe() {
      if (this.isSetSwipe) return;
      this.isSetSwipe = true;

      this.oSwiper = new Swiper(this.$refs['swiper'], {
        modules: [FreeMode, Scrollbar, Mousewheel],
        speed: 600,
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          hide: false,
          dragSize: 'auto',
        },
        on: {
          lock: function(e) {
            // console.log('lock', e);
            e.$el[0].classList.add('swiper--center');
          },
          unlock: function(e) {
            // console.log('unlock', e);
            e.$el[0].classList.remove('swiper--center');
          },
        }
      });
    },
    resize() {
      // if (gPG.isDevice === 'pc' || this.preWidth !== window.innerWidth) {
        if (this.getMatchMedia(1000)) {
          this.isCenter = false;
          this.isSetSwipe = false;
          if (!this.oSwiper) return;
          this.oSwiper.destroy(false, true);
        } else if((window.innerWidth - 200) > this.$el.querySelector('.swiper-wrapper').scrollWidth) {
          this.isCenter = true;
          this.isSetSwipe = false;
          if (!this.oSwiper) return;
          this.oSwiper.destroy(false, true);
        } else {
          this.isCenter = false;
          if (!this.oSwiper) return;
          this.settingSwipe();
        }
      // }

      this.preWidth = window.innerWidth;
    },
    vueImgLoaded(e) {
    },
    loaded(e) {
      this.counter++;
      if (this.max === this.counter) {
        this.$nextTick(this.once);
      }
    },
    getMatchMedia(width) {
      return window.matchMedia('(max-width: ' + width +'px)').matches;
    },
  }
}
</script>